import React, { useState, useEffect } from "react";
import "./manage-groups-page.scss";
import moment from "moment";
import ContactHelper from "../../../../entities/contact/contact-helper";
import { useSelector } from "react-redux";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import 'react-phone-number-input/style.css';
import ContactApi from "../../../../api/contact-api";
import ThreadApi from "../../../../api/thread-api";
import ThreadHelper from "../../../../entities/thread/thread-helper";
import { EventEmitter } from "../../../../shared/utils/event-emitter";
import Events from "../../../../const/events";
import ThreadChatModal from "../../components/thread-chat-modal/thread-chat-modal";
import ContactSearch from "../../components/contact-search/contact-search";
import usePageInfiniteScroll from "../../../../shared/utils/use-page-infinite-scroll";
import Card from "../../../../shared/components/dashboard-layout/components/card/cardComponent";
import Modal from "../../../../shared/components/dashboard-layout/modalComponent";
import { Tooltip } from "react-tooltip";

const MIN_CONTACTS = 2;
const MAX_CONTACTS = 10;

const ContactInput = ({
  contactData,
  index,
  disabled,
  contactsLength,
  onRemoveContactSlot,
  onUpdateContactField,
  onBackToSearch,
  onContactSelect,
  onAddNewContact,
}) => {
  const showManualForm = contactData.showManual || contactData.contact;

  return (
    <div className={`contact-slot ${disabled ? "disabled" : ""}`}>
      <div className="contactInputBox">
        <div className="contactOuterLabel">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path d="M5 21C5 17.134 8.13401 14 12 14C15.866 14 19 17.134 19 21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
            </g>
          </svg>
          <span>Contact {index + 1}</span>
          {contactsLength > MIN_CONTACTS && !disabled && (
            <button
              className="btn btn-link btn-sm p-0 ms-auto text-danger"
              onClick={() => onRemoveContactSlot(contactData.id)}
              title="Remove contact"
              disabled={disabled}
            >
              <i className="fa fa-times"></i>
            </button>
          )}
        </div>

        <div className="inputBox">
          {showManualForm ? (
            <div>
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Contact name"
                value={contactData.name}
                onChange={(e) => onUpdateContactField(contactData.id, "name", e.target.value)}
                disabled={disabled}
              />
              <div className="phoneNumberWrapper mb-2">
                <div className="phone-input-container w-100">
                  <PhoneInputWithCountrySelect
                    placeholder="Enter phone number"
                    defaultCountry="GB"
                    value={contactData.mobile}
                    onChange={(value) => onUpdateContactField(contactData.id, "mobile", value)}
                    international={true}
                    withCountryCallingCode={true}
                    countryCallingCodeEditable={false}
                    countrySelectProps={{ unicodeFlags: true }}
                    disabled={disabled}
                  />
                </div>
              </div>
              <div className="platform-badge">
                <svg viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000" width="14" height="14">
                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g id="Color-" transform="translate(-700.000000, -360.000000)" fill="#67C15E">
                        <path d="M723.993033,360 C710.762252,360 700,370.765287 700,383.999801 C700,389.248451 701.692661,394.116025 704.570026,398.066947 L701.579605,406.983798 L710.804449,404.035539 C714.598605,406.546975 719.126434,408 724.006967,408 C737.237748,408 748,397.234315 748,384.000199 C748,370.765685 737.237748,360.000398 724.006967,360.000398 L723.993033,360.000398 L723.993033,360 Z M717.29285,372.190836 C716.827488,371.07628 716.474784,371.034071 715.769774,371.005401 C715.529728,370.991464 715.262214,370.977527 714.96564,370.977527 C714.04845,370.977527 713.089462,371.245514 712.511043,371.838033 C711.806033,372.557577 710.056843,374.23638 710.056843,377.679202 C710.056843,381.122023 712.567571,384.451756 712.905944,384.917648 C713.258648,385.382743 717.800808,392.55031 724.853297,395.471492 C730.368379,397.757149 732.00491,397.545307 733.260074,397.27732 C735.093658,396.882308 737.393002,395.527239 737.971421,393.891043 C738.54984,392.25405 738.54984,390.857171 738.380255,390.560912 C738.211068,390.264652 737.745308,390.095816 737.040298,389.742615 C736.335288,389.389811 732.90737,387.696673 732.25849,387.470894 C731.623543,387.231179 731.017259,387.315995 730.537963,387.99333 C729.860819,388.938653 729.198006,389.89831 728.661785,390.476494 C728.238619,390.928051 727.547144,390.984595 726.969123,390.744481 C726.193254,390.420348 724.021298,389.657798 721.340985,387.273388 C719.267356,385.42535 717.856938,383.125756 717.448104,382.434484 C717.038871,381.729275 717.405907,381.319529 717.729948,380.938852 C718.082653,380.501232 718.421026,380.191036 718.77373,379.781688 C719.126434,379.372738 719.323884,379.160897 719.549599,378.681068 C719.789645,378.215575 719.62006,377.735746 719.450874,377.382942 C719.281687,377.030139 717.871269,373.587317 717.29285,372.190836 Z" id="Whatsapp"></path>
                      </g>
                    </g>
                  </g>
                </svg>
                <span>WhatsApp</span>
              </div>
              {!disabled && (
                <button
                  className="btn btn-link btn-sm p-0 mt-2"
                  onClick={() => onBackToSearch(contactData.id)}
                  disabled={disabled}
                >
                  Back to search
                </button>
              )}
            </div>
          ) : (
            <ContactSearch
              placeholder={`Search contact ${index + 1} by name, phone, or email...`}
              onContactSelect={(contact) => onContactSelect(contactData.id, contact)}
              onAddNewContact={(searchText) => onAddNewContact(contactData.id, searchText)}
              disabled={disabled}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const ManageGroupsPage = () => {
  const [groupTitle, setGroupTitle] = useState("");
  const [contacts, setContacts] = useState([
    { id: 1, contact: null, showManual: false, name: "", mobile: "" },
    { id: 2, contact: null, showManual: false, name: "", mobile: "" },
  ]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [connectionResult, setConnectionResult] = useState(null);
  const [previousGroups, setPreviousGroups] = useState([]);
  const [isLoadingGroups, setIsLoadingGroups] = useState(false);
  const [cloneSource, setCloneSource] = useState(null);
  const [cloneTitle, setCloneTitle] = useState("");
  const [cloneError, setCloneError] = useState("");
  const [isCloning, setIsCloning] = useState(false);

  // Get pagination info from Redux store
  const pagination = useSelector((state) => state?.threadStore?.pagination || {});
  const serviceAccessFetched = useSelector((state) => state?.userStore?.serviceAccessFetched);
  const hasValidServiceAccess = useSelector((state) => state?.userStore?.hasValidServiceAccess);
  
  // Infinite scroll setup for previous groups using page scroll
  const { isLoadingMore } = usePageInfiniteScroll(
    () => loadMoreGroups(),
    pagination.hasNextPage,
    isLoadingGroups
  );

  const { userInfo } = useSelector((state) => state.userStore);

  const hideB2cGroupChatForOrg = React.useMemo(() => {
    if (userInfo?.role !== "b2c") return false;
    const userOrgId = userInfo?._organizations?.[0];
    if (!userOrgId) return false;
    const blockedOrgIds = (process.env.REACT_APP_HIDE_B2C_GROUP_CHAT_ORG_IDS || "")
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);
    return blockedOrgIds.includes(String(userOrgId));
  }, [userInfo]);

  const getMemberDisplayName = (member) => member?.name || member?.phone || "Unknown";

  const getMemberStatus = (member) => {
    const status = String(member?.status || "invited").toLowerCase();
    return ["invited", "joined", "left"].includes(status) ? status : "invited";
  };

  const getCompactRelativeLastActive = (lastActiveAt) => {
    const lastActive = moment(lastActiveAt, moment.ISO_8601, true);
    if (!lastActive.isValid()) return "";

    const now = moment();
    const diffMinutes = Math.max(now.diff(lastActive, "minutes"), 0);

    if (diffMinutes < 1) return "now";
    if (diffMinutes < 60) return `${diffMinutes}min ago`;

    const diffHours = Math.max(now.diff(lastActive, "hours"), 0);
    if (diffHours < 24) return `${diffHours}h ago`;

    const diffDays = Math.max(now.diff(lastActive, "days"), 1);
    return `${diffDays}d ago`;
  };

  const getLastActiveFreshness = (lastActiveAt) => {
    const lastActive = moment(lastActiveAt, moment.ISO_8601, true);
    if (!lastActive.isValid()) return null;

    const diffHours = Math.max(moment().diff(lastActive), 0) / (60 * 60 * 1000);

    if (diffHours < 5) return { score: 100, className: "freshness-chip--100" };
    if (diffHours < 24) return { score: 80, className: "freshness-chip--80" };
    if (diffHours < 48) return { score: 60, className: "freshness-chip--60" };
    if (diffHours < 96) return { score: 30, className: "freshness-chip--30" };
    if (diffHours < 168) return { score: 10, className: "freshness-chip--10" };
    return { score: 0, className: "freshness-chip--0" };
  };

  const getMemberLastActive = (lastActiveAt) => {
    if (!lastActiveAt) {
      return {
        text: "No inbound message",
        relative: "",
        freshness: null,
        hasLastActive: false,
      };
    }

    const formatted = ThreadHelper.getFormattedDateTime(lastActiveAt, true);
    const relative = getCompactRelativeLastActive(lastActiveAt);
    if (formatted === "Invalid Date" || !relative) {
      return {
        text: "No inbound message",
        relative: "",
        freshness: null,
        hasLastActive: false,
      };
    }

    return {
      text: `Last active ${formatted}`,
      relative,
      freshness: getLastActiveFreshness(lastActiveAt),
      hasLastActive: true,
    };
  };

  const getGroupMembers = (thread) => {
    if (Array.isArray(thread?.groupMembers)) {
      return thread.groupMembers;
    }

    const fallbackMembers = new Map();
    const addFallbackMember = (member, status, index) => {
      if (!member) return;
      const key = member?._contact || member?._id || member?.phone || member?.name || index;
      const normalizedKey = String(key);
      const previous = fallbackMembers.get(normalizedKey) || {};
      fallbackMembers.set(normalizedKey, {
        ...previous,
        ...member,
        _contact: member?._contact || member?._id || previous._contact,
        status,
      });
    };

    (thread?.communicationMetadata || []).forEach((member, index) => {
      addFallbackMember(member, "invited", `invited-${index}`);
    });

    (thread?.metadata?.removedMembers?.contacts || []).forEach((member, index) => {
      addFallbackMember(member, "left", `left-${index}`);
    });

    (thread?._contacts || []).forEach((member, index) => {
      addFallbackMember(member, "joined", `joined-${index}`);
    });

    return Array.from(fallbackMembers.values());
  };

  const getMemberKey = (member, index) => (
    member?._contact || member?._id || member?.phone || member?.name || index
  );

  const getUniqueMembers = (members) => {
    const uniqueMembers = new Map();
    members.forEach((member, index) => {
      const key = String(getMemberKey(member, index));
      if (!uniqueMembers.has(key)) {
        uniqueMembers.set(key, member);
      }
    });
    return Array.from(uniqueMembers.values());
  };

  const renderMemberCell = (thread) => {
    const list = getUniqueMembers(getGroupMembers(thread));
    if (list.length === 0) {
      return <span className="text-muted members-empty">None</span>;
    }

    return (
      <div className="members-list">
        {list.map((member, index) => {
          const status = getMemberStatus(member);
          const lastActive = getMemberLastActive(member.lastActiveAt);
          return (
            <div className="member-row" key={member._contact || member._id || index}>
              <span className="member-name-with-phone">
                <span className="member-name">
                  {getMemberDisplayName(member)}
                </span>
                <span
                  className="member-phone-icon"
                  data-tooltip-id="memberPhoneTip"
                  data-tooltip-content={member.phone || "No mobile"}
                  aria-label={member.phone ? `Phone number: ${member.phone}` : "No mobile"}
                >
                  <i className="fa fa-mobile"></i>
                </span>
              </span>
              <span className={`member-status-badge member-status-badge--${status}`}>
                {status}
              </span>
              <span className="member-last-active">
                <span className="member-last-active__text">
                  {lastActive.text}
                </span>
                {lastActive.hasLastActive && lastActive.freshness && (
                  <span className={`freshness-chip ${lastActive.freshness.className}`}>
                    {lastActive.relative}
                  </span>
                )}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  // Get B2C users from a thread's _users array
  const getB2cUsers = (thread) => {
    if (!thread._users || !Array.isArray(thread._users)) return [];
    return thread._users.filter(user => user.role === 'b2c');
  };

  // Function to validate mobile numbers
  const validateMobileNumber = (mobile) => {
    let value = mobile?.trim() || "";
    value = value.replace(/[^+\d]/g, "");

    if (value === "") {
      return { isValid: false, error: "Phone number is required." };
    }

    if (!value.startsWith("+")) {
      return {
        isValid: false,
        error: "Phone number must start with a country code (e.g., +1 for USA).",
      };
    }

    const numericPart = value.replace("+", "");

    if (numericPart.length < 10) {
      return {
        isValid: false,
        error: "Phone number must have at least 10 digits (excluding country code).",
      };
    }

    if (numericPart.length > 15) {
      return {
        isValid: false,
        error: "Phone number must not exceed 15 digits.",
      };
    }

    return { isValid: true, formattedNumber: value };
  };

  // Process contact (check if exists or create new)
  const processContact = async (name, phone) => {
    try {
      const payload = { phone };
      const { data: checkResult } = await ContactApi.private.checkIfContactExists(payload);

      if (checkResult?.data?._id) {
        return checkResult.data._id;
      }

      throw new Error("Contact check returned an invalid response.");
    } catch (error) {
      if (error?.response?.status === 404) {
        try {
          const { contactId } = await ContactHelper.createNewContact({
            name,
            phone,
            preferredPlatform: "whatsapp",
          });

          if (contactId) {
            return contactId;
          }

          throw new Error("Failed to create new contact.");
        } catch (createError) {
          throw new Error(`Contact creation failed: ${createError.message}`);
        }
      }

      throw new Error(`Contact processing failed: ${error.message}`);
    }
  };

  // Get first name for group title
  const getFirstName = (fullName) => {
    return fullName?.split(" ")[0] || "";
  };

  // Create group thread
  const createGroupThread = async (contactIds, contactNames) => {
    try {
      const generatedTitle = groupTitle.trim() || contactNames.map(n => getFirstName(n)).join("+");

      const communicationMetadata = contactIds.map(contactId => ({
        _contact: contactId,
        preferredPlatform: "whatsapp",
      }));

      const response = await ThreadApi.private.createThread({
        type: "group",
        title: generatedTitle,
        _users: [],
        _contacts: contactIds,
        forceUpsert: true,
        metadata: {},
        communicationMetadata,
      });

      return { success: true, data: response?.data };
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Unknown error occurred";
      return { success: false, message: errorMessage };
    }
  };

  // Handle the create group button click
  const handleCreateGroup = async () => {
    // Validate group title (mandatory)
    if (!groupTitle.trim()) {
      setConnectionResult({
        success: false,
        message: "Group title is required.",
      });
      return;
    }

    // Validate all contacts
    const validContacts = [];
    
    for (let i = 0; i < contacts.length; i++) {
      const c = contacts[i];
      
      if (c.contact && !c.showManual) {
        // Selected from search
        if (!c.contact.phone) {
          setConnectionResult({
            success: false,
            message: `Contact ${i + 1}: Phone number is required for WhatsApp groups.`,
          });
          return;
        }
        validContacts.push({
          id: c.contact._id,
          name: c.contact.name,
          phone: c.contact.phone,
        });
      } else if (c.showManual || c.name || c.mobile) {
        // Manual entry
        const validation = validateMobileNumber(c.mobile);
        if (!validation.isValid) {
          setConnectionResult({
            success: false,
            message: `Contact ${i + 1}: ${validation.error}`,
          });
          return;
        }
        if (!c.name) {
          setConnectionResult({
            success: false,
            message: `Contact ${i + 1}: Name is required`,
          });
          return;
        }
        validContacts.push({
          id: null,
          name: c.name,
          phone: c.mobile,
        });
      }
    }

    if (validContacts.length < MIN_CONTACTS) {
      setConnectionResult({
        success: false,
        message: `Please add at least ${MIN_CONTACTS} contacts to create a group.`,
      });
      return;
    }

    // Check for duplicates
    const phoneNumbers = validContacts.map(c => c.phone);
    const uniquePhones = new Set(phoneNumbers);
    if (uniquePhones.size !== phoneNumbers.length) {
      setConnectionResult({
        success: false,
        message: "Duplicate contacts detected. Please ensure all contacts are unique.",
      });
      return;
    }

    setIsProcessing(true);
    setConnectionResult(null);

    try {
      const contactIds = [];
      const contactNames = [];

      for (const contact of validContacts) {
        let contactId;
        if (contact.id) {
          contactId = contact.id;
        } else {
          contactId = await processContact(contact.name, contact.phone);
        }
        contactIds.push(contactId);
        contactNames.push(contact.name);
      }

      const result = await createGroupThread(contactIds, contactNames);

      if (result.success) {
        setConnectionResult({
          success: true,
          message: "✅ Group Created Successfully",
        });
        // Reset the form
        setGroupTitle("");
        setContacts([
          { id: 1, contact: null, showManual: false, name: "", mobile: "" },
          { id: 2, contact: null, showManual: false, name: "", mobile: "" },
        ]);
        loadGroupThreads();
      } else {
        // Handle error - keep form enabled for user to retry
        setConnectionResult({
          success: false,
          message: `⚠️ ${result.message}`,
        });
      }
    } catch (error) {
      setConnectionResult({
        success: false,
        message: `⚠️ ${error.message || "Error: Could not create group."}`,
      });
    } finally {
      setIsProcessing(false);
    }
  };

  // Add a new contact slot
  const handleAddContactSlot = () => {
    if (contacts.length >= MAX_CONTACTS) {
      setConnectionResult({
        success: false,
        message: `Maximum ${MAX_CONTACTS} contacts allowed per group.`,
      });
      return;
    }
    const newId = Math.max(...contacts.map(c => c.id)) + 1;
    setContacts([...contacts, { id: newId, contact: null, showManual: false, name: "", mobile: "" }]);
  };

  // Remove a contact slot
  const handleRemoveContactSlot = (id) => {
    if (contacts.length <= MIN_CONTACTS) {
      setConnectionResult({
        success: false,
        message: `Minimum ${MIN_CONTACTS} contacts required.`,
      });
      return;
    }
    setContacts(contacts.filter(c => c.id !== id));
  };

  // Update contact selection
  const handleContactSelect = (id, contact) => {
    setContacts(contacts.map(c => {
      if (c.id === id) {
        return {
          ...c,
          contact,
          showManual: false,
          name: contact.name || "",
          mobile: contact.phone || "",
        };
      }
      return c;
    }));
  };

  // Handle add new contact for a slot
  const handleAddNewContact = (id, searchText) => {
    const isPhoneNumber = /^[+\d\s-]+$/.test(searchText);
    setContacts(contacts.map(c => {
      if (c.id === id) {
        return {
          ...c,
          showManual: true,
          contact: null,
          name: isPhoneNumber ? "" : searchText || "",
          mobile: isPhoneNumber ? searchText : "",
        };
      }
      return c;
    }));
  };

  // Update manual contact fields
  const updateContactField = (id, field, value) => {
    setContacts(contacts.map(c => {
      if (c.id === id) {
        return { ...c, [field]: value };
      }
      return c;
    }));
  };

  // Back to search for a contact slot
  const handleBackToSearch = (id) => {
    setContacts(contacts.map(c => {
      if (c.id === id) {
        return {
          ...c,
          showManual: false,
          contact: null,
          name: "",
          mobile: "",
        };
      }
      return c;
    }));
  };

  // Load group threads
  const loadGroupThreads = async () => {
    setIsLoadingGroups(true);
    try {
      await ThreadHelper.loadThreadsList({
        threadType: "group",
        includeGroupMemberStatus: true,
      });
      const { threadStore } = await import("../../../../redux/store").then(module => module.store.getState());
      const allThreads = threadStore?.allThreads || [];
      setPreviousGroups(allThreads);
    } catch (error) {
      console.error("Error loading group threads:", error);
    } finally {
      setIsLoadingGroups(false);
    }
  };

  // Load more groups for infinite scroll
  const loadMoreGroups = async () => {
    try {
      await ThreadHelper.loadNextPage({ includeGroupMemberStatus: true });
      const { threadStore } = await import("../../../../redux/store").then(module => module.store.getState());
      const allThreads = threadStore?.allThreads || [];
      setPreviousGroups(allThreads);
    } catch (error) {
      console.error("Error loading more group threads:", error);
    }
  };

  const getNextCloneTitle = (title) => {
    const base = title || "Group";
    const match = base.match(/^(.*?) - (\d+)$/);
    if (match) {
      return `${match[1]} - ${parseInt(match[2], 10) + 1}`;
    }
    return `${base} - 1`;
  };

  // Clone group handlers
  const handleOpenCloneModal = (thread) => {
    setCloneSource(thread);
    setCloneTitle(getNextCloneTitle(thread?.title));
    setCloneError("");
  };

  const handleCloseCloneModal = () => {
    if (isCloning) return;
    setCloneSource(null);
    setCloneTitle("");
    setCloneError("");
  };

  const buildCloneContacts = (thread) => {
    if (!thread) return [];
    const contactsById = new Map();
    (thread._contacts || []).forEach((c) => {
      if (c?._id) contactsById.set(String(c._id), c);
    });
    return (thread.communicationMetadata || []).map((meta) => {
      const fallback = contactsById.get(String(meta?._contact)) || {};
      return {
        _contact: meta?._contact,
        preferredPlatform: meta?.preferredPlatform,
        name: meta?.name ?? fallback.name,
        phone: meta?.phone ?? fallback.phone,
      };
    });
  };

  const handleConfirmCloneGroup = async () => {
    if (!cloneSource) return;

    const trimmed = cloneTitle.trim();
    if (!trimmed) {
      setCloneError("Group title is required.");
      return;
    }
    if (trimmed === (cloneSource.title || "").trim()) {
      setCloneError("New group title must be different from the source group.");
      return;
    }

    const cloneContacts = buildCloneContacts(cloneSource);
    const validContacts = cloneContacts.filter((c) => c._contact);
    if (validContacts.length === 0) {
      setCloneError("No contacts available to invite from this group.");
      return;
    }

    setIsCloning(true);
    setCloneError("");

    try {
      const response = await ThreadApi.private.createThread({
        type: "group",
        title: trimmed,
        _users: [],
        _contacts: validContacts.map((c) => c._contact),
        forceUpsert: true,
        metadata: {},
        communicationMetadata: validContacts.map((c) => ({
          _contact: c._contact,
          preferredPlatform: c.preferredPlatform || "whatsapp",
        })),
      });

      if (response?.data?.data) {
        setConnectionResult({
          success: true,
          message: "✅ Group reconnected successfully",
        });
        setCloneSource(null);
        setCloneTitle("");
        loadGroupThreads();
      } else {
        setCloneError("Failed to clone group.");
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || "Failed to clone group";
      setCloneError(errorMessage);
    } finally {
      setIsCloning(false);
    }
  };

  // View chat button handler
  const handleViewChat = (thread) => {
    ThreadHelper.makeThreadActive(thread);
    EventEmitter.dispatch(Events.SHOW_THREAD_CHAT_MODAL);
  };

  // Load group threads once service access is known and valid.
  // After login, serviceAccessFetched is reset to false and flips to true
  // asynchronously from DashboardLayout's org fetch — gate the load on it
  // so the initial fetch isn't swallowed by ThreadHelper's early return.
  useEffect(() => {
    if (!serviceAccessFetched) return;
    if (hasValidServiceAccess === false) return;
    loadGroupThreads();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceAccessFetched, hasValidServiceAccess]);

  // Contact input component
  

  return (
    <div className="manage-groups-page">
      <h1 className="mb-3 mt-0">Manage Groups</h1>

      <Card
        className={`createGroupWrapper mb-4 ${isProcessing ? 'processing' : ''}`}
        header="Create a new group"
        subheader={`Add ${MIN_CONTACTS} to ${MAX_CONTACTS} contacts for WhatsApp group messaging`}
        positiveButtonAction={!isProcessing ? handleCreateGroup : undefined}
        positiveButtonLabel={isProcessing ? (
          <>
            <img src="assets/images/ring-loader.svg" alt="loading" className="btn-loader me-2" style={{ width: '16px', height: '16px' }} />
            Creating Group...
          </>
        ) : "Create Group"}
        positiveButtonDisabled={isProcessing}
        notes={connectionResult ? connectionResult.message : ""}
        notesType={connectionResult?.success === false ? "error" : connectionResult?.success === true ? "success" : ""}
      >
        {isProcessing && (
          <div className="processing-overlay">
            <div className="processing-content">
              <img src="assets/images/ring-loader.svg" alt="loading" className="loader" />
              <p>Creating group, please wait...</p>
            </div>
          </div>
        )}

        <div className="group-title-input mb-4">
          <label className="form-label fw-semibold">
            Group Title <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter group title..."
            value={groupTitle}
            onChange={(e) => setGroupTitle(e.target.value)}
            disabled={isProcessing}
            required
          />
        </div>

        <div className="contacts-grid">
          {contacts.map((contactData, index) => (
            <ContactInput
              key={contactData.id}
              contactData={contactData}
              index={index}
              disabled={isProcessing}
              contactsLength={contacts.length}
              onRemoveContactSlot={handleRemoveContactSlot}
              onUpdateContactField={updateContactField}
              onBackToSearch={handleBackToSearch}
              onContactSelect={handleContactSelect}
              onAddNewContact={handleAddNewContact}
            />
          ))}
        </div>

        {contacts.length < MAX_CONTACTS && !isProcessing && (
          <div className="add-contact-btn mt-3">
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={handleAddContactSlot}
              disabled={isProcessing}
            >
              <i className="fa fa-plus me-2"></i>
              Add Another Contact
            </button>
          </div>
        )}

        <div className="contact-count-info mt-2">
          <small className="text-muted">
            {contacts.length} / {MAX_CONTACTS} contacts
          </small>
        </div>
      </Card>

      <Tooltip id="memberPhoneTip" place="top" />

      <Card
        className="previousGroupsWrapper mb-4"
        header="Previous Groups"
      >
        {isLoadingGroups ? (
          <div className="text-center my-5">
            <img src="assets/images/ring-loader.svg" alt="loader" className="loader" />
          </div>
        ) : previousGroups.length > 0 ? (
          <div className="tableWrapper" id="all_groups">
            <table className="table">
              <thead className="thead-light">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Group Name</th>
                  <th scope="col">Members</th>
                  <th scope="col">Created on</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {previousGroups.map((thread, index) => (
                  <tr key={thread._id}>
                    <th scope="row">{index + 1}</th>
                    <td>
                      <strong>{thread.title || "Unnamed Group"}</strong>
                    </td>
                    <td>{renderMemberCell(thread)}</td>
                    <td>
                      <div style={{ marginBottom: '8px' }}>
                        {new Date(thread.createdAt).toLocaleDateString()}
                      </div>
                      {(() => {
                        const b2cUsers = getB2cUsers(thread);
                        if (userInfo?.role !== 'b2c' && b2cUsers.length > 0) {
                          return (
                            <Card>
                              <div className="badge badge-soft-info mb-2">
                                <svg 
                                  width="10" 
                                  height="10" 
                                  viewBox="0 0 16 16" 
                                  fill="currentColor" 
                                  style={{ marginRight: '4px' }}
                                >
                                  <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                                </svg>
                                Co-ordinator
                              </div>
                              {b2cUsers.map((user, idx) => (
                                <div 
                                  key={user._id || idx} 
                                  style={{ 
                                    fontSize: '11px',
                                    marginBottom: idx < b2cUsers.length - 1 ? '8px' : '0',
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '6px'
                                  }}
                                >
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: 1 }}>
                                    <span style={{ 
                                      fontWeight: '600', 
                                      color: 'var(--text-primary)',
                                      lineHeight: '1.4'
                                    }}>
                                      {user.name || 'N/A'}
                                    </span>
                                    <span style={{ 
                                      color: '#64748b',
                                      fontSize: '10px',
                                      fontStyle: 'italic',
                                      lineHeight: '1.4',
                                      wordBreak: 'break-word'
                                    }}>
                                      {user.email || 'No email'}
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </Card>
                          );
                        }
                        return null;
                      })()}
                    </td>
                    <td>
                      {!hideB2cGroupChatForOrg && (
                        <button
                          className="customButton small white me-1"
                          onClick={() => handleViewChat(thread)}
                          title="View chat"
                        >
                          <i className="fa fa-eye"></i>
                        </button>
                      )}
                      <button
                        className="customButton small white"
                        onClick={() => handleOpenCloneModal(thread)}
                        title="Reconnect group with same contacts"
                      >
                        <i className="fa fa-sync"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Infinite scroll loading indicator */}
            {isLoadingMore && (
              <div className="text-center my-3">
                <img src="assets/images/ring-loader.svg" alt="loading more" className="loader" />
              </div>
            )}
          </div>
        ) : (
          <div className="alert alert-info text-center">
            No groups found. Create a new group to get started!
          </div>
        )}
      </Card>

      <ThreadChatModal />

      <Modal
        show={!!cloneSource}
        onClose={handleCloseCloneModal}
        header="Reconnect Group"
        buttons={true}
        onSave={handleConfirmCloneGroup}
        saveLabel={isCloning ? "Creating..." : "Create Group"}
        saveDisabled={isCloning}
      >
        {cloneSource && (
          <div className="clone-group-modal">
            <div className="form-group mb-3">
              <label className="form-label fw-semibold">
                New Group Title <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={cloneTitle}
                onChange={(e) => {
                  setCloneTitle(e.target.value);
                  if (cloneError) setCloneError("");
                }}
                disabled={isCloning}
                placeholder="Enter new group title"
              />
              <small className="text-muted d-block mt-1">
                Source: <strong>{cloneSource.title || "Unnamed Group"}</strong> (title must be different)
              </small>
            </div>

            <div className="form-group">
              <label className="form-label fw-semibold mb-2">
                Contacts to invite ({buildCloneContacts(cloneSource).length})
              </label>
              <div className="clone-contacts-list" style={{ maxHeight: "240px", overflowY: "auto", border: "1px solid #e5e7eb", borderRadius: "6px" }}>
                {buildCloneContacts(cloneSource).map((c, idx) => (
                  <div
                    key={`${c._contact || "unknown"}-${idx}`}
                    className="d-flex justify-content-between align-items-center p-2"
                    style={{ borderBottom: "1px solid #f1f5f9" }}
                  >
                    <span style={{ fontWeight: 500 }}>{c.name || "Unknown"}</span>
                    <span className="text-muted" style={{ fontSize: "12px" }}>{c.phone || "—"}</span>
                  </div>
                ))}
              </div>
            </div>

            {cloneError && (
              <div className="alert alert-danger mt-3 mb-0" style={{ fontSize: "13px" }}>
                {cloneError}
              </div>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ManageGroupsPage;
